(function ($) {
  var __ = {
    body: $('body'),
    window: $(window),
    // Scene Controller
    controller: window._animations.base.controller,
    global: window._animations.base,
    ajax: {},
    fetch: new ScrollMagic.Scene(),
    splitText: {},

    loadAnimations: function () {
      var timeline = new TimelineMax();

      if (__.global.screen === "large") {

        __.splitText.body_text = __.global.splitText($('.pg-contact--top--content--body').find('p, h1,h2,h3,h4,h5,h6'));

        timeline
          .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
          .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right))
          .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2')
          .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left))
          .add(TweenMax.from($('.pg-contact--headline').find('.s-highlight__side'), 0.2, { width: 0 }))
          .add(TweenMax.from($('.pg-contact--headline').find('.pg-contact--title'), 0.2,  __.global.animations.slide.up));
        
          __.global.staggerDisplay( __.splitText.body_text, timeline);


          $('.pg-contact-form--row').each(function(){
            var _this = $(this);
            timeline.add(TweenMax.from(_this.get(0), 0.4, __.global.animations.fade.up));

          });
          timeline.add(TweenMax.from($('.pg-contact-form--footer').get(0), 0.4, __.global.animations.fade.up));

          

          timeline.add(TweenMax.from('.pg-contact--top--image-container', 0.4, __.global.animations.fade.right))


          .call(function () {
            __.global.completeLoadInAnimation();
            __.splitText.body_text.revert();
          })

          .add(TweenMax.from('.pg-contact--locations', 0.4, __.global.animations.fade.up))
          .add(TweenMax.from($('.pg-contact--locations--headline').find('.s-highlight__side'), 0.4, {
            width: 0
          }))
          .staggerFrom(__.global.prepareText($('.pg-contact--locations--title')), 0.4, __.global.animations.slide.up, 0)

          .add(TweenMax.from($('.pg-contact--locations--single__1'), 0.4, __.global.animations.fade.up))
          .add(TweenMax.from($('.pg-contact--locations--single__2'), 0.4, __.global.animations.fade.up))



          .add(TweenMax.from('.pg-contact--social', 0.4, __.global.animations.fade.right), '-=0.8')

          .staggerFrom(__.global.prepareText($('.pg-contact--social--title')), 0.4, __.global.animations.slide.up, 0)
          .add(TweenMax.from('.pg-contact--social--list', 0.4, __.global.animations.fade.up))


          .add(TweenMax.from('.pg-contact--join', 0.4, __.global.animations.fade.right), '-=0.8')

          .staggerFrom(__.global.prepareText($('.pg-contact--join--title')), 0.4, __.global.animations.slide.up, 0)
          .add(TweenMax.from('.pg-contact--join--button', 0.4, __.global.animations.fade.up))

        ;
        timeline.play();
      } else {

      }
    },

    scrollAnimations: function () {

    },

    // Function to call to setup functionality
    setup: function () {
      __.loadAnimations();
      __.scrollAnimations();
    }
  };
  // Attach Toolbox to window //
  if (typeof window._animations === "undefined") {
    window._animations = {};
  }
  window._animations.contact = __;
})(jQuery); // Fully reference jQuery after this point.
